// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import ExampleComponent1 from "./components/mobile-toggle.vue";
// import ExampleComponent2 from "./components/example-2.js";

// // you can also require modules if they support it…
// const ExampleModule1 = require('./components/mobile-toggle.vue');
// const ExampleModule2 = require('./components/example-2.js');

// // Some convenient tools to get you started…
// import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
// import AnimateOnPageLinks from "./components/AnimateOnPageLinks";


// Initialise our components on jQuery.ready…
// jQuery(function ($) {
//     ExampleComponent1.init();
//     ExampleModule2.init();
//     ReplaceObfuscatedEmailAddresses.init();
//     AnimateOnPageLinks.init();
// });

// Vue.js
window.app = new Vue({
    el: "#app",
    mounted() {
        this.handleHashLinkClick = (event) => {
            var link = event.target.closest('a[href]');

            if(!link) {
                return;
            }

            var href = link.getAttribute('href');

            if(!href || href.charAt(0) !== '#' || href === '#') {
                return;
            }

            this.closeMenu();
        };

        document.addEventListener('click', this.handleHashLinkClick, true);
    },
    beforeDestroy() {
        if(this.handleHashLinkClick) {
            document.removeEventListener('click', this.handleHashLinkClick, true);
        }
    },
    data: {
        form: [],
        opened: false,
        search: false,
        account: false,
        cartPopUpOpen: false,
        filterOpen: false,
        reviewOpen: false,
        textFull: false,
        descriptionExpand: false,
        specificationsExpand: false,
        couponExpand: false,
        checkoutCompany: false,
        checkoutShipping: false,
        checkoutEditBusiness: false,
        checkoutEditPersonal: false,
        checkoutEditBilling: false,
        checkoutEditShipping: false,
        checkoutEditComments: false,
        password: null,
        showPassword: false,
        demo: false,
        supportPopUp: false,
        videoPlay: false,
        checkoutToggle: false,
        activetab: 1,

        billing_zipcode: '',
        billing_street: '',
        billing_housenumber: '',
        billing_city: '',
        billing_outputzipcode: '',
        billing_addresEdit: false,
        billing_error: false,

        shipping_zipcode: '',
        shipping_street: '',
        shipping_housenumber: '',
        shipping_city: '',
        shipping_outputzipcode: '',
        shipping_addresEdit: false,
        shipping_error: false,
    },
    watch: {
        billing_zipcode: function(){
            this.billing_city = '';

            if (this.billing_zipcode.length >= 6 && this.billing_housenumber){
                this.BillingLookupZip()
            }
        },
        billing_housenumber: function(){
            this.billing_city = '';

            if (this.billing_zipcode.length >= 6 && this.billing_housenumber){
                this.BillingLookupZip()
            }
        },
        shipping_zipcode: function(){
            if (this.shipping_zipcode.length >= 6 && this.shipping_housenumber){
                this.ShippingLookupZip()
            }
        },
        shipping_housenumber: function(){
            if (this.shipping_zipcode.length >= 6 && this.shipping_housenumber){
                this.ShippingLookupZip()
            }
        }
    },
    methods: {
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        closeMenu() {
            this.opened = false;
            jQuery('.sub-menu').removeClass('active-menu');
        },
        setFocus() {
            this.$refs.search.focus();
        },
        BillingLookupZip() {
            var _this               = this;
            var billing_zipcode     = _this.billing_zipcode.replace(/\s/g, '');
            var billing_housenumber = _this.billing_housenumber;

            axios.get('https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=postcode:' + billing_zipcode + '&fq=' + billing_housenumber )
            .then(function (output){
                _this.billing_error             = false;
                _this.billing_city              = output.data.response.docs[0].woonplaatsnaam;
                _this.billing_street            = output.data.response.docs[0].straatnaam;
                _this.billing_outputzipcode     = output.data.response.docs[0].postcode;

            })
            .catch(function (error){
                _this.billing_error             = true;
                _this.billing_city              = "";
                _this.billing_street            = "";
                _this.billing_outputzipcode     = "";

            })
        },
        ShippingLookupZip() {
            var _this               = this;
            var shipping_zipcode     = _this.shipping_zipcode.replace(/\s/g, '');
            var shipping_housenumber = _this.shipping_housenumber;

            axios.get('https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=postcode:' + shipping_zipcode + '&fq=' + shipping_housenumber )
            .then(function (output){
                _this.shipping_error             = false;
                _this.shipping_city              = output.data.response.docs[0].woonplaatsnaam;
                _this.shipping_street            = output.data.response.docs[0].straatnaam;
                _this.shipping_outputzipcode     = output.data.response.docs[0].postcode;

            })
            .catch(function (error){
                _this.shipping_error             = true;
                _this.shipping_city              = "";
                _this.shipping_street            = "";
                _this.shipping_outputzipcode     = "";

            })
        }

    }

})




jQuery(document).ready(function() {
    // Call necessary functions directly on page load
    lightGalleryInit();
    init();
});

jQuery(document).on('click', '#button-program', function(){
    jQuery(this).hide();
    jQuery('#program > div.hidden').removeClass('hidden');
});

jQuery(document).on('click', '#button-topscorers', function(){
    jQuery(this).hide();
    jQuery('#topscorers > div.hidden').removeClass('hidden');
});

jQuery(document).on('click', '#button-winners', function(){
    jQuery(this).hide();
    jQuery('#winner-columns > div.hidden').removeClass('hidden');
});



function init() {

    // Sliders
    var imagesThumb = new Swiper('.image-thumbs', {
        direction: 'horizontal',
        slidesPerView: 6,
        spaceBetween: 10,
        shortSwipes: false,
        watchSlidesVisibility: false,
        breakpoints: {
            540: {
                slidesPerView: 8,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            1024: {
                direction: 'horizontal',
                slidesPerView: 6,
                spaceBetween: 10,
                slideToClickedSlide: true,
                allowTouchMove: true,
                shortSwipes: false,
                touchStartPreventDefault: false,
                touchRatio: 0
            },
        }
    });

    var imagesSlide = new Swiper('.image-slider', {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20,
        loop: false,
        grabCursor: false,
        arrows: true,
        longSwipesRatio: 0.05,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        thumbs: {
            swiper: imagesThumb
        },
        normalizeSlideIndex: false,
        breakpoints: {
            1024: {
                allowTouchMove: false
            },
        }
    });

    var pageSlide = new Swiper('.page-slider', {
        slidesPerView: 1.75,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        breakpoints: {
            640: {
                slidesPerView: 2.25,
            },
            840: {
                slidesPerView: 3.25,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        }

    });

    var productSlide = new Swiper('.product-slider', {
        slidesPerView: 1.5,
        freeMode: true,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        shortSwipes: false,
        // longSwipesRatio: 0.05,
        speed: 300,
        navigation: {
            nextEl: '.button-next-products',
            prevEl: '.button-prev-products',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.75,
                freeMode: true
            },
            640: {
                slidesPerView: 2.55,
                freeMode: true
            },
            768: {
                slidesPerView: 2.75,
                freeMode: true
            },
            960: {
                slidesPerView: 3.25,
                freeMode: true
            },
            1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 15,
                freeMode: true
            },
            1180: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 15,
                allowTouchMove: false
            },
            1600: {
                slidesPerView: 5,
                slidesPerGroup: 5,
            }
        }
    });


    var thumbSlide = new Swiper('.thumb-slider', {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        arrows: true,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3.25,
            },
            1024: {
                slidesPerView: 3.75,
                slidesPerGroup: 3.75,
                allowTouchMove: false
            }
        }
    });

    var categorySlide1 = new Swiper('.image-category-slider', {
        slidesPerView: 2.2,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        freeMode: true,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2.75,
                slidesPerGroup: 2.75,
            },
            768: {
                slidesPerView: 3.5,
                slidesPerGroup: 3.5,
            },
            1024: {
                slidesPerView: 5.25,
                freeMode: false,
                slidesPerGroup: 5.25,
                allowTouchMove: true
            }
        }
    });

    var categorySlide2 = new Swiper('.category-slider', {
        slidesPerView: 1.25,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        // freeMode: true,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.75,
            },
            600: {
                slidesPerView: 2.25,
            },
            768: {
                slidesPerView: 2.75,
                slidesPerGroup: 2.75,
                freeMode: true,
            },
            960: {
                slidesPerView: 2.75,
                slidesPerGroup: 2.75,
                freeMode: true,
            },
            1024: {
                slidesPerView: 3.15,
                freeMode: false,
                slidesPerGroup: 3,
                allowTouchMove: true
            },
            1600: {
                slidesPerView: 4.15,
                freeMode: false,
                slidesPerGroup: 4,
            }
        }
    });

    var cardSlider = new Swiper('.card-slider', {
        slidesPerView: 1.25,
        centeredSlides: false,
        spaceBetween: 20,
        loop: false,
        grabCursor: false,
        freeMode: true,
        breakpoints: {
            480: {
                slidesPerView: 1.5,
            },
            600: {
                slidesPerView: 1.75,
            },
            768: {
                slidesPerView: 2.25,
            },
            1024: {
                freeMode: false,
                spaceBetween: 20,
                slidesPerView: 3,
            }
        }
    });

    var accountSlider = new Swiper('.account-slider', {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 5,
        loop: false,
        grabCursor: false,
        freeMode: true,
        
    });

    var logoSlider = new Swiper('.logo-slider', {
        slidesPerView: "auto",
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        freeMode: true,
        navigation: {
            nextEl: '.button-logo-next',
            prevEl: '.button-logo-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 3.5,
            },
            600: {
                centeredSlides: false,
                slidesPerView: 5.25,
            },
            1024: {
                spaceBetween: 40,
                freeMode: false,
                centeredSlides: false,
                slidesPerView: "auto",
            },
            1920: {
                spaceBetween: 50,
            }
        }
    });

    var trustpilotSlide = new Swiper('.trustpilot-slider', {
        slidesPerView: 1.5,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        arrows: true,
        navigation: {
            nextEl: '.btn-next',
            prevEl: '.btn-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2.15,
            },
            800: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 30,
                allowTouchMove: false,
                slidesPerGroup: 3,
            }
        }
    });

    var pricingSlide = new Swiper('.pricing-slider', {
        slidesPerView: 1.35,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        breakpoints: {
            500: {
                slidesPerView: 1.5,
            },
            640: {
                slidesPerView: 2.1,
            },
            840: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
                allowTouchMove: false,
            },
        }

    });


    var uspSlider = new Swiper('.usp-slider', {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 20,
    });

    let cart_settings = {
        slidesPerView: 1.5,
        freeMode: true,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        shortSwipes: false,
        longSwipesRatio: 0.05,
        speed: 700,
        navigation: {
            nextEl: '.button-next-products',
            prevEl: '.button-prev-products',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.75,
                freeMode: true
            },
            640: {
                slidesPerView: 2.55,
                freeMode: true
            },
            768: {
                slidesPerView: 2.75,
                freeMode: true
            },
            960: {
                slidesPerView: 2.75,
                freeMode: true
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1200: {
                slidesPerView: 2.25,
                slidesPerGroup: 3,
                allowTouchMove: false,
            }
        }
    }

    jQuery(document.body).on('removed_from_cart updated_cart_totals', function () {

        var cartSlider = new Swiper('.cart-slider', cart_settings);

    });
    var cartSlider = new Swiper('.cart-slider', cart_settings);

    


    // Quantity plus or down value
    jQuery(function($) {

        setInterval(function() {

            var value_qty       = jQuery('.qty').val();
            var value_min_qty   = jQuery('.qty').attr('min');
            var value_max_qty   = jQuery('.qty').attr('max');

            // Disable down button
            if(value_qty == value_min_qty) {
                jQuery('.qty-down').addClass('text-gray-400');
                jQuery('.qty-down').removeClass('text-black hover:text-gray-500');
            }
            else {
                jQuery('.qty-down').removeClass('text-gray-400');
                jQuery('.qty-down').addClass('text-black hover:text-gray-500');
            }

            // Disable up button
            if(value_qty == value_max_qty) {
                jQuery('.qty-up').addClass('text-gray-400');
                jQuery('.qty-up').removeClass('text-black hover:text-gray-500');
            }
            else {
                jQuery('.qty-up').removeClass('text-gray-400');
                jQuery('.qty-up').addClass('text-black hover:text-gray-500');
            }

        }, 0);


        jQuery(document).on("click", ".qty-toggle", function () {

            var $button     = $(this);
            var qtyItem     = $button.closest('.qty-item');
            var oldValue    = qtyItem.find('.qty').val();
            var attrButton  = $button.attr('data-id');
            var attrMin     = qtyItem.find('.qty').attr('min');
            var attrMax     = qtyItem.find('.qty').attr('max');

            if (attrButton == "plus") {
                if(parseInt(oldValue) < parseInt(attrMax)) {
                    var newVal = parseFloat(oldValue) + 1;
                }

            }
            if (attrButton == "min") {
                if(parseInt(oldValue) > parseInt(attrMin)) {
                   if (oldValue > 0) {
                        var newVal = parseFloat(oldValue) - 1;
                    } else {
                        newVal = 1;
                    }
                }
            }
            if(newVal) $button.closest('.qty-item').find('.qty').val(newVal).change();

        });
    });


    let oldValue = 0;

    window.addEventListener('scroll', function(e){
        var element     = document.getElementById("mobile-menu");

        if (element !== null) {
            // Get the new Value
            newValue = window.pageYOffset;

            //Subtract the two and conclude
            if(newValue >= 20) element.classList.add("shadow-menu");
            if(newValue <= 20) element.classList.remove("shadow-menu");

            // Update the old value
            oldValue = newValue;
        }
    });



   

    // YouTube video
    jQuery('.video').click(function(event) {
        var video       = jQuery('.video').find('iframe');
        var video_src   = jQuery('.video').find('iframe').attr('src');

        var video_url   = video_src + '&autoplay=1';

        video.attr('src', video_url);
    });

    // Loader
    if($('.search-filter-results').length) {
        var intervalId = window.setInterval(function(){
          var searchFilter  = $('.search-filter-results');
          var productLoader = $('.product-loader');

          if(searchFilter.length) {
            var positionLeft  = searchFilter.offset().left;
            var elementWidth  = searchFilter.width() / 2;
            var elementheight   = $(window).height() / 2;
            var sum       = positionLeft + elementWidth;
            productLoader.css({
              'left' : sum + 'px',
              'top' : elementheight + 'px',
            });
          }

        }, 100);
    }

    // Coupon click
    jQuery(document).on('click','#couponButton', function(event){
        jQuery(".coupon").css('display', 'flex');
    });

    function getVueApp() {
        if(window.app) {
            return window.app;
        }

        var appElement = document.getElementById('app');
        return appElement && appElement.__vue__ ? appElement.__vue__ : null;
    }

    function closeMobileMenu() {
        var app = getVueApp();

        if(app) {
            app.opened = false;
        }

        jQuery('.sub-menu').removeClass('active-menu');
    }

    // Menu click
    jQuery(document).on('click','.menu-item-has-children a', function(event){

        if (jQuery(window).width() < 1024) {

            if(jQuery(this).next().length > 0) {
                var item = jQuery(this).next().find('.mobile-menu-items'); 
                
                if(item.find('.menu-depth-prev').length == 0) {
                    var text = jQuery(this).text(); 
                    item.prepend('<div class="flex flex-row menu-depth-prev w-full py-3 px-6 text-sm font-bold border-b border-gray-200 cursor-pointer"><svg class="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1.293,12.707a1,1,0,0,1,0-1.414l6-6A1,1,0,0,1,8.707,6.707L4.414,11H22a1,1,0,0,1,0,2H4.414l4.293,4.293a1,1,0,0,1-1.414,1.414Z"/></svg><span class="menu-depth-prev-text">' +  text + '</span></div>');                
                }

                jQuery(this).next().addClass('active-menu');
                event.preventDefault();
            }
                
        } 

    });


    // Menu remove click
    jQuery(document).on('click','.menu-depth-prev', function(event){
        jQuery(this).closest('.sub-menu').removeClass('active-menu');
    });
    jQuery(document).on('click','.background-menu-active, .close-icon', function(event){
        closeMobileMenu();
    });


    var distance        = jQuery('.divider-place-order');
    if(distance.length) {

        distance = jQuery('.divider-place-order').offset().top

        var className;
        var classMobile     = 'fixed bottom-0 left-0 md:relative w-full bg-white md:bg-transparent p-4 md:p-0 shadow-checkout md:shadow-none duration-300';
        var classDesktop    = 'relative w-full mt-4 md:hidden duration-300';

        var windowHeight = jQuery(window).height();

        if(jQuery(window).width() < 768) className = classMobile;
        if(jQuery(window).width() >= 768) className = classDesktop;

        if(jQuery(window).width() < 768) {
            jQuery(window).scroll(function () {
                var sum = Number(distance) - Number(windowHeight);

                console.log('scroll: ' + jQuery(window).scrollTop() + ' - Positie: ' + sum);

                if (jQuery(window).scrollTop() >= sum) className = classDesktop;
                if (jQuery(window).scrollTop() <= sum) className = classMobile;

                jQuery('#place_order_section').removeClass();
                jQuery('#place_order_section').addClass(className);
            });
        }
    }

}
function lightGalleryInit() {
    const lightGalleryElements = document.querySelectorAll('[data-lightgallery]');

    lightGalleryElements.forEach((lightGalleryElement) => {
        lightGallery(lightGalleryElement, {
            videojs: true,
            thumbnail: true,
            animateThumb: false,
            showThumbByDefault: true,
        });
    });
}

function programScrollInit() {
    const scrollToProgram = () => {
        const programSection = document.getElementById('programma');

        if (programSection) {
            programSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    document.querySelectorAll('[data-scroll-to-programma]').forEach((link) => {
        link.addEventListener('click', (event) => {
            const linkUrl = new URL(link.href, window.location.origin);

            if (linkUrl.pathname === window.location.pathname) {
                event.preventDefault();
                window.history.replaceState(null, '', '#programma');
                scrollToProgram();
            }
        });
    });

    if (window.location.hash === '#programma') {
        window.addEventListener('load', scrollToProgram, { once: true });
    }
}


lightGalleryInit();
programScrollInit();
init();
